import { JavaVulnerability } from './JavaVulnerability';

export class JavaProvider {
  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly version: string,
    private readonly vulnerabilities: JavaVulnerability[]
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getVersion() {
    return this.version;
  }

  getVulnerabilities() {
    return this.vulnerabilities;
  }
}
